export const baseAccountApiUrl = '/1.0/public/account/external/';
export const baseAccountPublicApiUrl = '/1.0/public/accounts/public/';
export const baseCartApiUrl = '/1.0/public/cart/external/';
export const baseOrderApiUrl = '/1.0/public/order/external/';
export const baseOrdersContactApiUrl = '/1.0/public/orders/contact/';
export const baseRefundApiUrl = '/1.0/public/refund/external/';
export const baseContactApiUrl = '/1.0/public/contact/external';
export const baseConsentHubApiUrl = '/1.0/public/consenthub';
